module.exports = __webpack_public_path__ + "static/media/icon_refresh.ef355dd9.svg";